import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { AppPagination } from '@/client/components/_atoms'
import CsvDownload from '@/client/components/_atoms/csv_download'

import { InstagramInstantwinMessageSendCountRow, MessageSendCountSortBy } from '../types'

interface Props {
  prizeId: number | null
  rows: InstagramInstantwinMessageSendCountRow[]
  total: number
  pagingNo: number
  limitCount: number
  sortBy: MessageSendCountSortBy | ''
  loading: boolean
  downloadCsv: () => Promise<any> | any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramInstantwinCampaignAnalyticsMessageSendCountsTab',
  props: {
    prizeId: null,
    rows: null,
    total: null,
    pagingNo: null,
    limitCount: null,
    sortBy: null,
    loading: { type: Boolean },
    downloadCsv: null
  },
  emits: ["sort-change", "paging"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'sort-change', value: MessageSendCountSortBy | ''): void
  (e: 'paging', payload: { currentPage: number; pageSize: number }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  prizeId: number | null
  rows: InstagramInstantwinMessageSendCountRow[]
  total: number
  pagingNo: number
  limitCount: number
  sortBy: MessageSendCountSortBy | ''
  loading: boolean
  downloadCsv: () => Promise<any> | any
};

// @ts-nocheck TODO: 既存の型エラーを解消したら外す




const defaultSort = computed(() => {
  if (!props.sortBy) return undefined
  const key = props.sortBy.startsWith('-') ? props.sortBy.slice(1) : props.sortBy
  const order = props.sortBy.startsWith('-') ? 'descending' : 'ascending'
  return { prop: key, order }
})

const handleSortChange = (payload: {
  column?: { columnKey?: string; property?: string }
  prop?: string
  order?: 'ascending' | 'descending'
}) => {
  if (props.loading) return
  const key = payload.column?.columnKey || payload.column?.property || payload.prop
  if (!key) return
  if (!payload.order) {
    emit('sort-change', '')
    return
  }
  const sortKey =
    payload.order === 'descending' ? (`-${key}` as MessageSendCountSortBy) : (key as MessageSendCountSortBy)
  emit('sort-change', sortKey)
}

const handlePaging = (payload: { currentPage: number; pageSize: number }) => {
  emit('paging', payload)
}

const messageLabel = (value: string | null) => {
  return value && value.trim().length > 0 ? value : '-'
}

const tableMaxHeight = 400

return { __sfc: true,props, emit, defaultSort, handleSortChange, handlePaging, messageLabel, tableMaxHeight, AppPagination, CsvDownload }
}

})